import React, {useState, useEffect} from 'react';
import { Card, Button, Form, Modal } from 'react-bootstrap';
import { shallowEqual, useSelector } from 'react-redux';
import {toast} from 'react-toastify';
import { toastOption } from '../../../../../../../../_metronic/_helpers';

export const UploadImageModal = ({show, onHide, confirm}) => {
  const { actionsLoading, kurbanReportForEdit, error } = useSelector(
    (state) => ({
      kurbanReportForEdit: state.kurbanReport.kurbanReportForEdit,
      actionsLoading: state.kurbanReport.actionsLoading,
      error: state.kurbanReport.error
    }),
    shallowEqual,
  );
  
  const [imageBefore, setImageBefore] = useState(null);
  const [imageAfter, setImageAfter] = useState(null);
  const [imageBeforeInput, setImageBeforeInput] = useState(null);
  const [imageAfterInput, setImageAfterInput] = useState(null);
  
  useEffect(() => {
    if (error) {
      toast.error(error, toastOption);
    }
  }, [error]);

  useEffect(() => {
    if(kurbanReportForEdit) {
      const {after_photo, before_photo} = kurbanReportForEdit;

      if(after_photo) {
        const {storage, path} = after_photo;
        
        setImageAfter(`${storage}/${path}`);
      }

      if(before_photo) {
        const {storage, path} = before_photo;
        
        setImageBefore(`${storage}/${path}`);
      }
    }
  }, [kurbanReportForEdit]);

  useEffect(() => {
    if(imageAfterInput instanceof File) {
      setImageAfter(URL.createObjectURL(imageAfterInput));
    }

    if(imageBeforeInput instanceof File) {
      setImageBefore(URL.createObjectURL(imageBeforeInput));
    }
  }, [imageAfterInput, imageBeforeInput]);
  
  function submitConfirm() {
    confirm(imageAfterInput, imageBeforeInput);
  }
  
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className='bg-warning' closeButton>
        <Modal.Title className='text-white'>
          Ubah Foto
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Form */}
        <div className="w-100">
          <Form onSubmit={submitConfirm}>
            {/* Foto Sebelum */}
            <Form.Group controlId="formFile" className="mb-5">
              <Form.Label className="font-weight-bold h3">Foto Sebelum</Form.Label>
              <Card className="mb-4" style={{ width: '24rem', objectFit: 'cover' }}>
                <Card.Img variant="top" src={imageBefore} />
              </Card>
              <Form.Control 
                type="file" 
                onChange={(e) => {
                  const [image] = e.target.files;

                  setImageBeforeInput(image);
                }}
              />
            </Form.Group>
            {/* Foto Sebelum */}
            
            {/* Foto Sesudah */}
            <Form.Group controlId="formFile" className="mb-5">
              <Form.Label className="font-weight-bold h3">Foto Sesudah</Form.Label>
              <Card className="mb-4" style={{ width: '24rem', objectFit: 'cover' }}>
                <Card.Img variant="top" src={imageAfter} />
              </Card>
              <Form.Control 
                type="file" 
                onChange={(e) => {
                  const [image] = e.target.files;

                  setImageAfterInput(image);
                }}
              />
            </Form.Group>
            {/* Foto Sesudah */}
          </Form>
        </div>
        {/* Form */}

        {/* Buttons */}
        <div className="d-flex flex-row justify-content-end">
          <Button className='mr-4' variant="secondary" onClick={onHide}>
            Kembali
          </Button>
          <Button width={75} variant="primary" onClick={submitConfirm}>
            {!actionsLoading ? 
              <span>
                Konfirmasi
              </span>
              :
              <span>
                <i className="fas fa-circle-notch fa-spin"></i>
              </span>
            }
          </Button>
          {/* Buttons */}
        </div>
      </Modal.Body>
    </Modal>
  );
}